import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { GenericTable } from "../../../components/GenericTable/GenericTable";
import { useSessionContext } from "../../../contexts/SessionContext";
import { isMobile } from "react-device-detect";
import { useFormatter } from "../../../utils/useFormatter";
import dayjs from "dayjs";
import { DependentListActions } from "./DependentListActions";
import { Check, Warning } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { GetConsents } from "../../../services/consent";

const translateSex: any = {
  male: "Masculino",
  female: "Feminino",
};

export function DependentList() {
  const { patientRelated, user } = useSessionContext();

  const [received, setReceived] = useState([]);


  const getColumns = (rows: any[]) => {
    let cols = [
      { column: "Nome", rowName: "name" },
      { column: "CPF", rowName: "identifier" },
    ];

    // Verifica se ao menos 1 linha tem birthDate válido (não vazio, null ou "-")
    const hasBirthDate = rows?.some(
      (el: any) =>
        el &&
        el.birthDate &&
        el.birthDate !== "-" &&
        el.birthDate !== "" &&
        el.birthDate !== undefined
    );

    if (hasBirthDate) {
      cols.push({ column: "Data de nascimento", rowName: "birthDate" });
    }

    // Verifica se ao menos 1 linha tem gender válido (não vazio, null, undefined, "unknown" ou "-")
    const hasGender = rows?.some(
      (el: any) =>
        el &&
        el.gender &&
        el.gender !== "unknown" &&
        el.gender !== "-" &&
        el.gender !== "" &&
        el.gender !== undefined
    );

    if (hasGender) {
      cols.push({ column: "Sexo de nascimento", rowName: "gender" });
    }

    cols.push({ column: "Verificado", rowName: "active" });
    cols.push({ column: "Status", rowName: "ends" });

    return cols;
  };

  const mobileColumns = [
    { column: "Nome", rowName: "name" },
    { column: "CPF", rowName: "identifier" },
  ];

  const rows = patientRelated
    ?.map((el: any) => ({
      name: useFormatter.formatNameDisplay(el?.name?.[0]?.text),
      identifier: useFormatter.formatCPF(el?.id?.split("-")[1] || ""),
      birthDate: el?.birthDate ? dayjs(el?.birthDate).format("DD/MM/YYYY") : undefined,
      gender: translateSex[el?.gender || "unknown"],
      active: el?.isVerify ? (
        <Tooltip title="Verificação realizada">
          <Check color="primary" />
        </Tooltip>
      ) : (
        <>
          {el?.period?.start ? (
            <Tooltip title="Verificação pendente">
              <Warning sx={{ color: "warning500.main" }} />
            </Tooltip>
          ) : (
            <> - </>
          )}
        </>
      ),
      ends: el?.period?.end ? "Inativo" : "Ativo",
      start: el?.period?.start,
      end: el?.period?.end,
      relatedId: el?.relatedId,
      verify: el?.isVerify,
      fullResource: el,
    }))
    ?.sort((a: any, b: any) => a?.name?.localeCompare(b?.name))
    ?.sort((a: any, b: any) => b?.verify - a?.verify);


  useEffect(() => {
    async function fetchData() {
      try {
        const receivedResponse = await GetConsents({
          identifier: user.username,
          type: "received",
        });
        setReceived(
          receivedResponse?.data
            ?.filter(
              (el: any) =>
                el?.recurso?.id !== user.username && el?.recurso?.nome
            )
            ?.map((el: any) => ({
              id: el?.recurso?.id,
              purpose: el?.contexto?.motivoAcesso,
            }))
        );
      } catch (err) {
        console.log("Fetch consents", err);
      } finally {
      }
    }
    fetchData();
  }, [user.username]);

  return (
    <Stack width="100%">
      <Accordion
        defaultExpanded
        disableGutters
        sx={{
          border: "1px solid #ccc",
          boxShadow: "1px 1px 8px 1px rgba(0, 0, 0, 0.2)",
          position: "initial",
          marginBottom: "20px",
        }}
      >
        <AccordionSummary
          expandIcon={<GridExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Lista de dependentes</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <GenericTable
            tableColumns={isMobile ? mobileColumns : getColumns(rows)}
            tableRows={rows}
            actions={(rowData: any) => (
              <DependentListActions row={rowData} received={received} />
            )}
          />
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}
